module.exports = __webpack_public_path__ + "img/syukyaku-kyu-001sp.72f1ab22.jpg";